import { reviews } from '@/mocks/comics';

export default function UserReviews() {
  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`text-xs ${i < rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
      ></i>
    ));
  };

  return (
    <section className="py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
            漫友热评
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            听听漫友们
            <span className="font-heading italic text-primary-500">怎么说</span>
          </h2>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="break-inside-avoid p-5 bg-background-50 rounded-xl border border-background-200 hover:border-accent-200 transition-colors"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.username}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{review.username}</div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {renderStars(review.rating)}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{review.content}&rdquo;
              </p>
              <p className="text-xs text-foreground-400 mt-3">{review.date}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}